import { useQuery } from '@tanstack/react-query';
import { getLocationsByIds, queryKeys } from '@vgrubs/components';

/**
 * Restaurant phone numbers, for the problems whose action is "call the
 * restaurant" (tabletOffline, printerError). A problem carries the location's
 * id but not its phone, so the card asks for every such location at once and
 * the detail for its one.
 *
 * Phones change rarely, so they are kept for the session.
 */
export const useLocationPhones = (locationIds: number[]) => {
  const ids = [...new Set(locationIds)].sort((a, b) => a - b);

  const query = useQuery({
    queryKey: queryKeys.systemProblems.locationPhones(ids),
    queryFn: async () => {
      const { data } = await getLocationsByIds(ids);
      return Object.fromEntries(
        data.data.map((location) => [location.id, location.phoneNumber])
      ) as Record<number, string | null>;
    },
    enabled: ids.length > 0,
    staleTime: Infinity,
  });

  return (locationId: number | null) =>
    locationId === null ? null : query.data?.[locationId] ?? null;
};
